<template>
  <div class="field">
    <label class="label" v-html="label" />
    <span v-if="multi">
      <input
        v-for="obj in selected_items"
        :key="obj.id"
        :name="`${name}[]`"
        :value="obj.id"
        type="hidden"
      />
    </span>
    <span v-if="!multi">
      <input
        :name="`${name}`"
        :value="selected_items ? selected_items.id : ''"
        type="hidden"
      />
    </span>
    <VueMultiselect
      v-model="selected_items"
      :placeholder="label"
      :options="items"
      :multiple="multi"
      :searchable="true"
      :loading="isLoading"
      :internal-search="true"
      :clear-on-select="true"
      :close-on-select="true"
      :options-limit="300"
      :limit="limit"
      :limit-text="limitText"
      :show-labels="true"
      label="name"
      :track-by="track_by"
      :allow-empty="allow_empty"
      :preselect-first="preselect_first"
      :disabled="disabled"
    >
      <span slot="noResult">
        Oops! No items found. Consider changing the search query.
      </span>
    </VueMultiselect>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';

export default {
  name: 'Multiselect',

  components: {
    VueMultiselect
  },

  props: {
    label: { type: String, required: true },
    name: { type: String, required: true },
    value: { default: () => [] }, // eslint-disable-line vue/require-prop-types
    items: { type: Array, required: true },
    multi: { type: Boolean, default: true },
    preselect_first: { type: Boolean, default: false },
    allow_empty: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    return_property: { type: String, required: false, default: null },
    track_by: { type: String, default: 'id' },
    limit: { type: Number, default: 3 },
    default_values: { type: Array, default: () => [] }
  },

  data() {
    return {
      selected_items: this.value,
      isLoading: false
    };
  },

  watch: {
    // this is needed to enable v-model functionality
    selected_items(val) {
      this.emitSelectedValue(val);
    }
  },

  created() {
    if (this.default_values.length) {
      this.selected_items = this.items.filter((item) => {
        return this.default_values.includes(item[this.track_by]);
      });
    }
    this.emitSelectedValue(this.selected_items);
  },

  methods: {
    limitText(count) {
      return `and ${count} other items`;
    },

    emitSelectedValue(val) {
      if (this.return_property) {
        let value = null;
        if (this.multi) {
          value = [];
          val.forEach(v => value.push(v[this.return_property]));
        } else if (val !== null) {
          value = val[this.return_property];
        }
        this.$emit('input', value);
      } else {
        this.$emit('input', val);
      }
    }
  }
};
</script>
